import type { MouseEvent } from 'react'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { SortDirection } from './types'

interface SortHeaderProps {
  label: string
  active: boolean
  direction: SortDirection
  /** When part of a multi-column sort, 1-based position. Hidden when single-sort. */
  priority?: number
  onSort: (event: { shiftKey: boolean }) => void
  className?: string
}

export function SortHeader({ label, active, direction, priority, onSort, className }: SortHeaderProps) {
  const Icon = active ? (direction === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => onSort({ shiftKey: e.shiftKey })
  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        'flex items-center gap-1 font-medium hover:text-foreground transition-colors',
        active ? 'text-foreground' : 'text-muted-foreground',
        className,
      )}
      title="Klik = sortuj. Shift+klik = dodaj kolejne kryterium."
    >
      <span>{label}</span>
      <Icon className="size-3.5" aria-hidden />
      {active && priority !== undefined && priority > 0 && (
        <span className="rounded bg-muted text-[10px] font-mono px-1 leading-4 text-muted-foreground">
          {priority}
        </span>
      )}
    </button>
  )
}
